/* Cosi Kids collectiepagina 2.0
   Alleen geladen op de ck-collectietemplates.
   - Snel toevoegen door op een maat te klikken
   - Automatisch bijladen bij het scrollen
   - Alleen de gekozen filters tonen, en geen filters zonder keuze
   - Maatchips, productteller en de vaste balk bovenin
   - Filters als vaste zijkolom op desktop, sorteren als keuzelijst rechtsboven */
(function () {
  function getCart() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function addVariant(variantId, button) {
    if (!variantId || button.disabled) return;
    var cart = getCart();
    button.classList.add('ck-size-btn--loading');

    var body = new FormData();
    body.append('id', variantId);
    body.append('quantity', 1);

    if (cart && typeof cart.getSectionsToRender === 'function') {
      var sections = cart.getSectionsToRender().map(function (section) {
        return section.id;
      });
      body.append('sections', sections);
      body.append('sections_url', window.location.pathname);
    }

    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        button.classList.remove('ck-size-btn--loading');
        if (response.status) return;

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ck-product-card', productVariantId: variantId });
        }

        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(response);
        }
      })
      .catch(function () {
        button.classList.remove('ck-size-btn--loading');
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.ck-size-btn');
    if (!button) return;
    event.preventDefault();
    addVariant(button.dataset.variantId, button);
  });

  /* Automatisch bijladen: we klikken de bestaande "Toon meer"-knop van het
     thema zodra die in de buurt van het scherm komt. Zo blijft alle
     laadlogica (ophalen, toevoegen, knop verbergen aan het eind, en de
     afstemming met de filters) in pagination.js staan. De knop blijft in de
     pagina als terugvaloptie wanneer het bijladen faalt. */
  var pending = false;

  function maybeLoadMore() {
    var button = document.querySelector('#component-pagination-loader .js-load-more');
    if (!button) return;
    if (button.classList.contains('hide')) return;
    if (button.disabled || button.classList.contains('btn--loading')) return;

    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    if (button.getBoundingClientRect().top <= viewportHeight * 1.5) {
      button.click();
    }
  }

  /* De header van het thema plakt bovenaan en schuift weg bij naar beneden
     scrollen. De chipbalk en de filterkolom moeten daar precies onder blijven
     hangen, dus meten we de onderkant van de header mee in dezelfde
     frame-update.

     Het terugglijden van de header is een CSS-animatie, en daarbij komen er
     geen scroll-gebeurtenissen meer binnen. Daarom blijft deze functie
     bijhouden of de waarde nog verandert: zolang dat zo is, plannen we een
     volgende frame. Anders bleef de plakhoogte staan op de waarde van de
     weggeschoven header en viel de kop van de kolom achter de header. */
  var lastOffset = null;

  function updateStickyOffset() {
    var header = document.querySelector('.shopify-section-header');
    var offset = header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0;

    if (offset === lastOffset) return false;

    lastOffset = offset;
    document.documentElement.style.setProperty('--ck-sticky-top', offset + 'px');
    return true;
  }

  function onFrame() {
    pending = false;

    var moving = updateStickyOffset();
    maybeLoadMore();

    // Blijf meten zolang de header nog beweegt.
    if (moving) scheduleCheck();
  }

  function scheduleCheck() {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(onFrame);
  }

  window.addEventListener('scroll', scheduleCheck, { passive: true });
  window.addEventListener('resize', scheduleCheck, { passive: true });
  scheduleCheck();

  /* Alleen de belangrijkste filters tonen. Welke dat zijn staat in de
     sectie-instelling "Welke filters tonen" (data-ck-filters op de grid-
     container). De rest verbergen we in de DOM in plaats van weg te laten,
     zodat de filterlogica van het thema intact blijft. Het overleeft ook de
     her-render na een filterwijziging, omdat facets.js alleen de binnenkant
     van .js-filter vervangt en niet het element zelf. */
  function normaliseLabel(text) {
    return text.replace(/\(.*\)/, '').trim().toLowerCase();
  }

  function alleFilterBlokken() {
    return document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter'
    );
  }

  function applyFilterWhitelist() {
    var grid = document.getElementById('ProductGridContainer');
    if (!grid) return;

    var raw = grid.getAttribute('data-ck-filters');
    if (!raw) return;

    var allowed = raw
      .split(',')
      .map(function (name) {
        return name.trim().toLowerCase();
      })
      .filter(Boolean);
    if (!allowed.length) return;

    alleFilterBlokken().forEach(function (block) {
      var labelEl = block.querySelector('.facets__summary__text span, .mobile-facets__summary span');
      if (!labelEl) return;

      var label = normaliseLabel(labelEl.textContent);
      if (!label) return;

      // Sorteren staat in dezelfde structuur op mobiel en moet blijven staan.
      if (block.querySelector('input[name="sort_by"]')) return;

      block.hidden = allowed.indexOf(label) === -1;
    });

    // "Filter toevoegen" hoort bij de weggelaten filters.
    var addMore = document.querySelector('.facets__add-more');
    if (addMore) addMore.hidden = true;
  }

  /* Een filter met maar één waarde is geen keuze. Op de merkpagina van
     Mitch & Son heeft "Geslacht" alleen de waarde Jongens: aanvinken verandert
     niets aan het overzicht. Bij Sofija staan jongens en meisjes door elkaar
     en is datzelfde filter juist nuttig.

     Dat verschil hoort niet in een instelling per collectie thuis, want alle
     merken delen één template. Vandaar deze regel, die vanzelf meebeweegt met
     de inhoud van de collectie. Draait na de witte lijst, want die zet
     hidden ook weer op false.

     Sorteren blijft buiten schot: dat is geen filter. Een prijsfilter ook, want
     dat heeft invoervelden en geen aankruisvakjes. */
  function verbergKeuzelozeFilters() {
    alleFilterBlokken().forEach(function (block) {
      if (block.hidden) return;
      if (block.querySelector('input[name="sort_by"]')) return;

      var waarden = block.querySelectorAll('input[type="checkbox"], input[type="radio"]');
      if (waarden.length === 1) block.hidden = true;
    });
  }

  function ordenFilters() {
    applyFilterWhitelist();
    verbergKeuzelozeFilters();
  }

  ordenFilters();
  document.addEventListener('DOMContentLoaded', ordenFilters);

  /* Sorteerlabels korter maken in de lade op mobiel. De namen komen van
     Shopify zelf (results.sort_options) en staan dus niet in de taalbestanden
     van het thema; ze zijn alleen in snippets/facets.liquid te wijzigen, en
     dat bestand is gedeeld met alle collecties. Vandaar hier.

     Op desktop is dit niet meer nodig: daar bouwt ck-collection-toolbar.liquid
     zijn eigen keuzelijst op, met de namen al goed. */
  var SORT_LABELS = {
    'created-descending': 'Nieuwste eerst',
    'created-ascending': 'Oudste eerst'
  };

  function renameSortOptions() {
    document.querySelectorAll('input[name="sort_by"]').forEach(function (input) {
      var label = SORT_LABELS[input.value];
      if (!label) return;

      var item = input.closest('li');
      if (!item) return;

      item
        .querySelectorAll('.facet-checkbox__text, .mobile-facets__label-text, .visually-hidden')
        .forEach(function (element) {
          element.textContent = label;
        });

      input.setAttribute('data-sort-name', label);
    });

    var selected = document.querySelector('.facet-filters__selected-sort');
    var checked = document.querySelector('input[name="sort_by"]:checked');
    if (selected && checked && SORT_LABELS[checked.value]) {
      selected.textContent = SORT_LABELS[checked.value];
    }
  }

  renameSortOptions();
  document.addEventListener('DOMContentLoaded', renameSortOptions);

  /* Sorteren op desktop. De keuzelijst rechtsboven zet de bijbehorende radio
     van het thema aan en laat facets.js het ophalen doen. Zo blijft er ook
     hier maar één filtersysteem: de sortering, de telling en de paginering
     komen allemaal van Shopify.

     facets.js luistert naar "input" op het formulier, vandaar een gebeurtenis
     die opborrelt. Is de radio er niet, dan blijft een gewone paginawissel
     over als terugvaloptie. */
  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-ck-sorteer]');
    if (!select) return;

    var radio = document.querySelector(
      '#FacetFiltersForm input[name="sort_by"][value="' + select.value + '"]'
    );

    if (!radio) {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.href = url.toString();
      return;
    }

    radio.checked = true;
    radio.dispatchEvent(new Event('input', { bubbles: true }));
    radio.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Op desktop staan de filters in een vaste zijkolom. Daar horen ze open te
     staan: dichtgeklapte secties zijn zinvol bij acht filters, niet bij twee.
     Het thema levert ze dicht aan, dus we klappen ze hier eenmalig open. */
  function openDesktopFacets() {
    if (window.innerWidth < 990) return;

    var form = document.getElementById('FacetFiltersForm');
    if (!form) return;

    form.querySelectorAll('details.facets__filters__details').forEach(function (details) {
      details.open = true;
    });
  }

  openDesktopFacets();
  document.addEventListener('DOMContentLoaded', openDesktopFacets);

  /* Shop de look: de pijlen op desktop schuiven het spoor precies één kaart
     op. Op mobiel wordt er geswipet en zijn de pijlen verborgen. De breedte
     van een kaart lezen we uit de DOM, zodat de CSS de maat blijft bepalen. */
  document.addEventListener('click', function (event) {
    var knop = event.target.closest('[data-ck-look]');
    if (!knop) return;

    event.preventDefault();

    var blok = knop.closest('.ck-look');
    var spoor = blok ? blok.querySelector('[data-ck-look-spoor]') : null;
    if (!spoor) return;

    var kaart = spoor.querySelector('.ck-look__kaart');
    var stap = kaart ? kaart.getBoundingClientRect().width + 12 : spoor.clientWidth;
    if (knop.dataset.ckLook === 'vorige') stap = -stap;

    spoor.scrollBy({ left: stap, behavior: 'smooth' });
  });

  /* Maatchips. De chip-URL komt van Shopify zelf (url_to_add/url_to_remove),
     we duwen hem alleen door de bestaande renderPage van het thema. Zo blijft
     er één filtersysteem en klopt de URL ook na het klikken. */
  document.addEventListener('click', function (event) {
    var chip = event.target.closest('[data-ck-chip]');
    if (!chip) return;

    event.preventDefault();

    if (typeof FacetFiltersForm === 'undefined') {
      window.location.href = chip.href;
      return;
    }

    var href = chip.getAttribute('href') || '';
    var query = href.indexOf('?') === -1 ? '' : href.slice(href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(query);
  });

  /* Balk op mobiel: opent de bestaande filterlade van het thema. De
     sorteerknop klapt daarin ook het sorteerblok open. */
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-ck-open-facets]');
    if (!trigger) return;

    event.preventDefault();

    var drawer = document.querySelector('.mobile-facets__wrapper details');
    if (!drawer) return;

    var summary = drawer.querySelector('summary');
    if (summary && !drawer.hasAttribute('open')) summary.click();

    if (trigger.hasAttribute('data-ck-open-sort')) {
      var sortInput = drawer.querySelector('.mobile-facets__details input[name="sort_by"]');
      if (sortInput) {
        var details = sortInput.closest('details');
        if (details) details.open = true;
      }
    }
  });

  /* Na een filterwijziging ververst het thema een vaste lijst elementen. De
     chips, de teller en de sorteerlijst zitten daar niet bij, dus haken we er
     hier op aan in plaats van facets.js aan te passen (dat bestand is gedeeld
     met alle collecties). */
  if (typeof FacetFiltersForm !== 'undefined') {
    var renderAdditional = FacetFiltersForm.renderAdditionalElements;

    FacetFiltersForm.renderAdditionalElements = function (html) {
      renderAdditional.call(FacetFiltersForm, html);

      ['#ck-size-chips', '#ck-toolbar-meta'].forEach(function (selector) {
        var source = html.querySelector(selector);
        var target = document.querySelector(selector);
        if (source && target) target.innerHTML = source.innerHTML;
      });

      ordenFilters();
      renameSortOptions();
    };
  }
})();
